<template lang="pug">
div
  promoModal
  //- #modal-4anni.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered.modal-fullscreen
      .ci-cmsg-wrapper
        .ci-cmsgbox
          .bbg
            img(src='assets/img/nov/pop.png')
          .ccon
            .ttext Please contact our Livechat to claim your MYR 33 Angpao
            .bclose(data-bs-dismiss='modal' aria-label='Close' @click="openChat") CONFIRM
            .ttext The MYR 1111 winners will be announced on 12 November 2024
  .access
    .button-area
      template(v-if="!isLoggedIn")
        a.btn-login(href='javascript:void(0)' @click="openModal('#modal-login')") {{$t('ui.login')}}
        a.btn-register.animate__animated.animate__heartBeat.animate__infinite(href='javascript:void(0)' @click="openModal('#modal-register01')") {{$t('ui.register')}}
      template(v-else)
        .welcomebox {{ $t('ui.hi') }} {{ getDisplayName }}
          span {{ $store.getters.currencyCode }} {{ $numeral($store.getters.balance).format("0,0.00") }}
          span(style="color:yellow") 11.11 Angpow : {{ $store.getters.currencyCode }} {{ $numeral(rayaAngpow * 0.5).format("0,0.00") }}
        router-link.angpao.pointer(to="deposit")
          img(src="assets/img/angpao.gif" )
      .dropdown.lang
        button#lang.btn.dropdown-toggle(type='button' data-bs-toggle='dropdown' aria-expanded='false')
          a(href='javascript:void(0)')
            img(:src="'assets/img/lang/'+getLanguage+'.svg'")
        ul.dropdown-menu(aria-labelledby='lang')
          li
            a(href='javascript:void(0)' @click="setLanguage('en')")
              img(src='assets/img/lang/en.svg')
          li
            a(href='javascript:void(0)' @click="setLanguage('my')")
              img(src='assets/img/lang/my.svg')
          li
            a(href='javascript:void(0)' @click="setLanguage('zh')")
              img(src='assets/img/lang/zh.svg')
  template(v-if="showContent")
    .notification-wrap
      .marquee
        .icon-wrap
          .icon
            i.fa.fa-bullhorn(aria-hidden='true')
        span.marquee-1
          span.text(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
          span.text(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
          span.marquee-2
            span.text(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
            span.text(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
    //- .ann
      .icon
        i.fa-solid.fa-bullhorn
      .text
        marquee#mqAnnouncement.mt-1(onmouseover='this.stop();' onmouseout='this.start();' scrollamount='10')
          span.me-5(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
          span.me-5(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
          span.me-5(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
          span.me-5(v-html="$t('ui.marquee.announcement', { url: getUrl() })")
    .banner
      #carouselBanner.carousel.slide(data-bs-ride='carousel')
        .carousel-indicators
          button.active(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='0' aria-current='true' aria-label='Slide 1')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='1' aria-label='Slide 2')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='2' aria-label='Slide 3')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='3' aria-label='Slide 4')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='4' aria-label='Slide 5')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='5' aria-label='Slide 6')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='6' aria-label='Slide 7')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='7' aria-label='Slide 8')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='8' aria-label='Slide 9')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='9' aria-label='Slide 10')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='10' aria-label='Slide 11')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='11' aria-label='Slide 12')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='12' aria-label='Slide 13')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='13' aria-label='Slide 14')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='14' aria-label='Slide 15')
          button(type='button' data-bs-target='#carouselBanner' data-bs-slide-to='15' aria-label='Slide 16')
          button(v-if="$helpers.timingControl('2024-11-12 21:00') === true" type='button' data-bs-target='#carouselBanner' data-bs-slide-to='16' aria-label='Slide 17')
          //- button(v-if="showRtp" type='button' data-bs-target='#carouselBanner' data-bs-slide-to='16' aria-label='Slide 17')
        .carousel-inner
          .carousel-item.pointer(v-if="$helpers.timingControl('2024-11-12 21:00') === true" :class="{'active': $helpers.timingControl('2024-11-12 21:00') === true}" @click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/lucky-desktop.jpg')
          .carousel-item.pointer(:class="{'active': $helpers.timingControl('2024-11-12 21:00') === false}" @click="customPath('promotions', 14)")
            img.d-block.w-100(src='assets/img/main-banner/1111-desktop.jpg')
          //- .carousel-item.pointer.active(@click="customPath('promotions', 14)")
            img.d-block.w-100(src='assets/img/main-banner/1111-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/wukong-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/welcome-desktop.jpg')
          .carousel-item.pointer(@click="customPath('missions', 2)")
            img.d-block.w-100(src='assets/img/main-banner/daily-desktop.jpg')
          .carousel-item.pointer(@click="customPath('https://pp88.asia/promotion/daily-wins/', 1)")
            img.d-block.w-100(:src="'assets/img/main-banner/pp-desktop-'+getLanguage+'.jpg'")
          //- .carousel-item.pointer(@click="customPath('https://history.jlfafafa3.com/event/20240730_Dragon_MY', 1)")
            img.d-block.w-100(:src="'assets/img/main-banner/jili-desktop-'+getLanguage+'.jpg'")
          //- .carousel-item.pointer(v-if="showRtp")
            img.d-block.w-100(src='assets/img/main-banner/rtp99-desktop.jpg')
          .carousel-item.pointer(@click="openChat")
            img.d-block.w-100(src='assets/img/main-banner/4d-desktop.jpg')
          .carousel-item.pointer(@click="customPath('promotions', 10)")
            img.d-block.w-100(src='assets/img/main-banner/birthday-desktop.jpg')
          .carousel-item.pointer(@click="customPath('https://t.me/epicwininfinity', 1)")
            img.d-block.w-100(src='assets/img/main-banner/luckydraw-desktop.jpg')
          .carousel-item.pointer(@click="customPath('promotions', 15)")
            img.d-block.w-100(src='assets/img/main-banner/comeback-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/casino-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/tng-desktop.jpg')
          .carousel-item.pointer(@click="customPath('promotions', '07')")
            img.d-block.w-100(src='assets/img/main-banner/referral-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/followus-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/free-desktop.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/contact-desktop.jpg')  
    .banner-m
      #carouselBannerM.carousel.slide(data-bs-ride='carousel')
        .carousel-indicators
          button.active(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='0' aria-current='true' aria-label='Slide 1')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='1' aria-label='Slide 2')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='2' aria-label='Slide 3')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='3' aria-label='Slide 4')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='4' aria-label='Slide 5')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='5' aria-label='Slide 6')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='6' aria-label='Slide 7')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='7' aria-label='Slide 8')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='8' aria-label='Slide 9')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='9' aria-label='Slide 10')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='10' aria-label='Slide 11')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='11' aria-label='Slide 12')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='12' aria-label='Slide 13')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='13' aria-label='Slide 14')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='14' aria-label='Slide 15')
          button(type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='15' aria-label='Slide 16')
          button(v-if="$helpers.timingControl('2024-11-12 21:00') === true" type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='16' aria-label='Slide 17')
          //- button(v-if="showRtp" type='button' data-bs-target='#carouselBannerM' data-bs-slide-to='16' aria-label='Slide 17')
        .carousel-inner
          .carousel-item.pointer(v-if="$helpers.timingControl('2024-11-12 21:00') === true" :class="{'active': $helpers.timingControl('2024-11-12 21:00') === true}" @click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/lucky-mobile.jpg')
          .carousel-item.pointer(:class="{'active': $helpers.timingControl('2024-11-12 21:00') === false}" @click="customPath('promotions', 14)")
            img.d-block.w-100(src='assets/img/main-banner/1111-mobile.jpg')
          //- .carousel-item.pointer.active(@click="customPath('promotions', 14)")
            img.d-block.w-100(src='assets/img/main-banner/1111-mobile.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/wukong-mobile.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/welcome-mobile.jpg')
          .carousel-item.pointer(@click="customPath('missions', 2)")
            img.d-block.w-100(src='assets/img/main-banner/daily-mobile.jpg')
          .carousel-item.pointer(@click="customPath('https://pp88.asia/promotion/daily-wins/', 1)")
            img.d-block.w-100(:src="'assets/img/main-banner/pp-mobile-'+getLanguage+'.jpg'")
          //- .carousel-item.pointer(@click="customPath('https://history.jlfafafa3.com/event/20240730_Dragon_MY', 1)")
            img.d-block.w-100(:src="'assets/img/main-banner/jili-mobile-'+getLanguage+'.jpg'")
          //- .carousel-item.pointer(v-if="showRtp")
            img.d-block.w-100(src='assets/img/main-banner/rtp99-mobile.jpg')
          .carousel-item.pointer(@click="openChat")
            img.d-block.w-100(src='assets/img/main-banner/4d-mobile.jpg') 
          .carousel-item.pointer(@click="customPath('promotions', 10)")
            img.d-block.w-100(src='assets/img/main-banner/birthday-mobile.jpg')  
          .carousel-item.pointer(@click="customPath('https://t.me/epicwininfinity', 1)")
            img.d-block.w-100(src='assets/img/main-banner/luckydraw-mobile.jpg')
          .carousel-item.pointer(@click="customPath('promotions', 15)")
            img.d-block.w-100(src='assets/img/main-banner/comeback-mobile.jpg')         
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/casino-mobile.jpg')       
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/tng-mobile.jpg')
          .carousel-item.pointer(@click="customPath('promotions', 2)")
            img.d-block.w-100(src='assets/img/main-banner/referral-mobile.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/followus-mobile.jpg')
          
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/free-mobile.jpg')
          .carousel-item.pointer(@click="redirectPath")
            img.d-block.w-100(src='assets/img/main-banner/contact-mobile.jpg')
    //- .banner-freecredit.pointer(v-if="!isLoggedIn" @click="openModal('#modal-register01')")
      img(src="assets/img/free_angbow.gif")
    //- .dbar-wrapper
      .dbar
        .iimg
          img(src='assets/img/dbar/roof.png')
        .ccon
          .ffloat
            img(src='assets/img/dbar/angpao.gif')
          .ttitle
            img(src='assets/img/dbar/title.png')
          .pbar(v-if="isLoggedIn")
            span.bars(:style="'width:'+depoProgress+'%'")
            span RM{{$numeral(depoAmount).format("0,0.00")}} / RM{{$numeral(targetAmount).format("0,0.00")}}
          .ddate 10 Feb 2024 - 24 Feb 2024
          .bbtn
            img(v-if="depoProgress < 100" src='assets/img/dbar/more-btn.png' @click="moreInfo")
            img(v-else src='assets/img/dbar/claim-btn.png' @click="openChat")
    .realtime-trans
      .tt {{ $t("ui.real_time") }}
        br
        | {{ $t("ui.transaction") }}
      .ccon
        .rtt-wrap
          .vv-rtt
            template(v-if="topTenList")
              div(v-for="x in topTenList")
                .rttbox
                  .rimg
                    img(src='assets/img/user.png')
                  .rcon
                    div
                      span {{ x.member_id }}
                      span.time {{$moment(x.action_date).locale(getLanguageDisplay).fromNow()}}
                    div
                      span {{ $tc('ui.topten_'+x.transfer_type) }}
                      span.amo {{ $store.getters.currencyCode }} {{ x.transfer_amount.toFixed(2) }}
    //- .ninedeals.anni-wrapper
      .anni.pointer(@click="checkStatus")
        .iimg
          img(src='assets/img/nov/title.png')
        .ccon
          .subtitle End 11 Nov
          .pbar(:class="{'border-0' : !isLoggedIn}")
            template(v-if="isLoggedIn")
              div(class='ffloat animate__animated animate__headShake animate__slower animate__infinite' )
                img(src='assets/img/nov/depo.png')
              span.bars(:style="'width:'+depoProgress+'%'")
              span MYR{{$numeral(depoAmount).format("0,0.00")}} / MYR{{$numeral(targetAmount).format("0,0.00")}} 
            template(v-else)
              div(class='ffloat animate__animated animate__headShake animate__slower animate__infinite' )
                img(src='assets/img/nov/depo.png')
              span.bars(:style="'width:0%'")
              span MYR{{$numeral(0).format("0,0.00")}} / MYR{{$numeral(1111).format("0,0.00")}} 
    .checkinbox.home.pointer(@click="triggerAction(true)")
      .ttitle
        img(src='assets/img/check-in/title.png')
      //- .subtitle Deposit & Earn MYR 300
      .ci-wrapper
        template(v-for="(data, index) in dataDay")
          //- .cib.pointer(:class="[{'claimed' : data.claimed===true}, {'ready' : data.ready === true}]" @click="triggerAction(data.ready)")
          .cib.pointer(:class="[{'claimed' : data.claimed===true}, {'ready' : data.ready === true}]")
            .ci-date(v-if="data.claimed")
              span {{ data.date }}
            .bbg
              img(src='assets/img/check-in/unlock.png')
            .tt {{data.day}}
            //- .amount(v-if="data.claimed") {{ data.date }}
            //- .iimg
              img(:src="'assets/img/check-in/c'+(index+1)+'.png'")
        .cibfs
          i.fa-solid.fa-plus
          .bbg
            img(src="assets/img/check-in/freespin-tb.png")
      .progress(v-if="isLoggedIn")
        //- template(v-for="(data, index) in dataDay")
        .pdot.p1(:class="{'active': dataDay[0].claimed === true}")
        .pdot.p2(:class="{'active': dataDay[1].claimed === true}")
        .pdot.p3(:class="{'active': dataDay[2].claimed === true}")
        .pdot.p4(:class="{'active': dataDay[3].claimed === true}")
        .pdot.p5(:class="{'active': dataDay[4].claimed === true}")
        .progress-bar(role="progressbar" :style="'width:'+getClaimed+'%'")
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
import promoModal from '@/components2/_promotionDetails.vue'
import promoContent from '@/components2/promotionTable/_promoContent.vue'
import { EventBus } from '@/event-bus';
export default {
  components:{
    promoContent,
    promoModal
  },
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      bankList: [],
      loading:false,
      counter: 0,
      currentPath: "",
      showContent: true,
      topTenList: [],
      depoAmount:"",
      targetAmount: "",
      depoProgress: "",
      // rayaAngpow: "",
      dataDay:[
        {day: "Day 1", claimed: "", ready: "",},
        {day: "Day 2", claimed: "", ready: "",},
        {day: "Day 3", claimed: "", ready: "",},
        {day: "Day 4", claimed: "", ready: "",},
        {day: "Day 5", claimed: "", ready: "",},
      ],
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    currentBalance() {
      return this.$store.getters.balance
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    inboxList(){
      return this.$store.state.user.inbox
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getLanguageDisplay(){
      return this.$tc(`ui.language.${this.$store.getters.language}`) || this.$tc('ui.language.en')
    },
    showRtp(){
      var now = this.$moment().day()
      var hour = this.$moment().hour()
      if ((now === 2 && hour >= 20) || (now === 3) || (now === 4 && hour < 2)) {
        return true;
      } else {
        return false;
      }
    },
    getClaimed(){
      var count = this.dataDay.filter(item=> item.claimed === true).length;
      if(count < 4){
        return count * 25
      }else{
        return 100
      }
    },
    rayaAngpow(){
      return this.$store.state.user.depositCount
    }
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
      this.showContent = this.$helpers.routeCheck(to.path)
      if(this.showContent === true){
        // this.cnyDeposit()
        this.rayaDeposit()
        this.missionDetails()
      }
      // if(to.path === '/promotions' || to.path === '/inbox' || to.path === '/profile'){
      //   this.showContent = false
      // }else{
      //   this.showContent = true
      // }
    },
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.dataDay = [
          {day: "Day 1", claimed: "", ready: "", date:""},
          {day: "Day 2", claimed: "", ready: "", date:""},
          {day: "Day 3", claimed: "", ready: "", date:""},
          {day: "Day 4", claimed: "", ready: "", date:""},
          {day: "Day 5", claimed: "", ready: "", date:""},
        ]
        this.depoAmount = ""
      }else{
        if(this.showContent === true){
          // this.cnyDeposit()
          this.rayaDeposit()
          this.missionDetails()
        }
      }
    }
  },
  beforeUpdate(){
    $('.vv-rtt').filter('.slick-initialized').slick('unslick');
  },
  updated(){
    $('.vv-rtt').not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      slidesToShow: 6,
      slidesToScroll: 1,
      pauseOnFocus: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
    // this.getTopTenDepWit();
    // this.getGraphData();
  },
  mounted() {
    this.currentPath = this.$router.currentRoute.fullPath
    this.showContent = this.$helpers.routeCheck(this.$router.currentRoute.fullPath)
    // if(this.$router.currentRoute.fullPath === '/promotions' || this.$router.currentRoute.fullPath === '/inbox' || this.$router.currentRoute.fullPath === '/profile'){
    //   this.showContent = false
    // }else{
    //   this.showContent = true
    // }
    // if(!_.isEmpty(this.$route.query)){
    //   if(this.$route.query.coupon){
    //     if(!this.$store.getters.isLoggedIn && !this.$route.query.ref && !this.$route.query.affiliatecode){
    //       $("#modal-login").modal("show");
    //     }else{
    //       $("#modal-coupon").modal("show");
    //     }
    //   }
    // }
    // if (this.$store.getters.isLoggedIn) {
    //   this.getBalance()
    //   // this.getInboxList()
    // }
    this.getTopTenDepWit()
    if(this.isLoggedIn){
      if(this.showContent === true){
        // this.cnyDeposit()
        this.rayaDeposit()
        this.missionDetails()
      }
      
    }
    // this.refreshInbox = setInterval(() => {
    //   if (this.$store.getters.isLoggedIn) {
    //     this.counter++;
    //     if(this.counter == 2){
    //       this.setNewLoop();
    //       clearInterval(this.refreshInbox)
    //     }else{
    //       this.getInboxList()
    //     }
    //   }
    // }, 15000)
  },
  beforeDestroy: function() {
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
  },
  methods: {
    checkStatus(){
      if(this.isLoggedIn){
        if(this.depoAmount >= 1111){
          $('#modal-4anni').modal("show")
        }
      }else{
        $('#modal-login').modal("show")
      }
      // this.$helpers.redirect('euro2024')
    },
    // missionDetails(){ 
    //   var vm = this
    //   if (this.sessionToken) {
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     this.$store
    //       .dispatch("user/missionDetails", { account_id, auth_token })
    //       .then(response => {
    //         if (response.success == true) {
    //           if(response.data.length > 0){
    //             for(let i = 0; i < response.data.length; i++){
    //               if(this.$moment(response.data[i].deposit_date).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD")){
    //                 this.depoAmount = response.data[i].deposit_amount
    //                 this.depoProgress = parseFloat(response.data[i].deposit_amount) / 520 * 100
    //               }
    //             }
    //           }else{
                
    //           }
              
    //         } else {
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }              
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }  
    //       });
    //   }
      
    // },
    missionDetails(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/missionDetails", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              // var temp = response.data.length
              this.dayComplete = response.data.length
              if(response.data.length > 0){
                var latestDate = this.$moment(response.data[this.dayComplete-1].deposit_date).format("YYYY-MM-DD")
                var currentDate = this.$moment(new Date()).format("YYYY-MM-DD")
                for(let i = 0; i < this.dayComplete; i++){
                  // if(this.depoAmount === ''){
                  //   this.depoAmount = response.data[i].deposit_amount
                  // }else{
                  //   this.depoAmount = this.depoAmount + response.data[i].deposit_amount
                  // }
                  this.dataDay[i].claimed = true
                  this.dataDay[i].date = this.$moment(response.data[i].deposit_date).format("MM/DD")
                  if(latestDate !== currentDate){
                    if(latestDate.localeCompare(currentDate) === -1 && (this.dayComplete-i === 1)){
                      if(i+1 < 5){
                        this.dataDay[i+1].ready=true
                      } 
                    }
                  }
                  if(this.$moment(response.data[i].deposit_date).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD")){/* daily event*/
                    this.depoAmount = response.data[i].deposit_amount
                  }
                }
                // this.targetAmount = 188 /* daily event*/
                // this.depoProgress = parseFloat(this.depoAmount) / this.targetAmount * 100 /* daily event*/
                // if(this.depoProgress > 100){
                //   this.depoProgress = 100
                // }
                // if(this.depoAmount >= 150 && this.depoAmount < 300){
                //   this.accuProgress = 100/6
                // }else if(this.depoAmount >= 300 && this.depoAmount < 1000){
                //   this.accuProgress = 100/6*2
                // }else if(this.depoAmount >= 1000 && this.depoAmount < 1500){
                //   this.accuProgress = 100/6*3
                // }else if(this.depoAmount >= 1500 && this.depoAmount < 3000){
                //   this.accuProgress = 100/6*4
                // }else if(this.depoAmount >= 3000 && this.depoAmount < 6000){
                //   this.accuProgress = 100/6*5
                // }else if(this.depoAmount >= 6000){
                //   this.accuProgress = 100
                // }else{
                //   this.accuProgress = 0
                // }
              }else{
                this.dataDay[0].ready = true
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    triggerAction(target){
      // if(target === true){
      //   this.$router.push("deposit").catch(error =>{})
      // }
      this.$router.push("missions").catch(error =>{})
    },
    moreInfo(){
      $("#cny-info").modal("show")
    },
    openChat(){
      $('#modal-4anni').modal("hide")
      LiveChatWidget.call("maximize");
    },
    rayaDeposit(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/rayaDeposit", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                // this.rayaAngpow = response.data[0].deposit_count
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    cnyDeposit(){ /* accumulate */
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/cnyDeposit", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.depoAmount = response.data[0].deposit_amount
                this.targetAmount = response.data[0].target_amount
                this.depoProgress = parseFloat(response.data[0].deposit_amount) / parseFloat(response.data[0].target_amount) * 100
                if(this.depoProgress > 100){
                  this.depoProgress = 100
                }
              }else{
                this.targetAmount = 1111
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    customPath(link, target){
      if(target === 1){
        setTimeout(() => {
          window.open(link, "_blank")
        }) 
      }else if(target === 2){
        this.$router.push(link).catch(error =>{})
      }else if(target === 3){
        // this.$router.push({
        //   name:"slot",
        //   params:{
        //     "event": true
        //   }
        // }).catch(error =>{})
        // EventBus.$emit('event');  
        this.$router.push(link).catch(error =>{}).finally(() => {
          this.$nextTick(() => {
            EventBus.$emit('event');
          });
        });
      }else{
        $("#modal-promo"+target).modal("show")
        // var page = window.location.protocol + "//" +window.location.hostname + link
        // setTimeout(() => {
        //   window.open(page, "_blank")
        // })
        // this.$router.push(link).catch(error =>{})
        // this.$router.push({
        //   name:link,
        //   params:{
        //     "target": target
        //   }
        // }).catch(error =>{})

      }
    },
    redirectPath(){
      if(this.isLoggedIn){
        this.$router.push("deposit").catch(error =>{})
      }else{
        $('#modal-login').modal('show')
      }
    },
    toInbox(){
      this.$router.push({
        name:"profile",
        params:{
          "inbox": true
        }
      }).catch(error =>{})
    },
    openModal(target){
      $(target).modal("show")
    },
    openReferral(){
      this.$router.push("referral").catch(error =>{})
    },
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload)
    },
    getUrl(){
      return window.location.hostname
    },
    redirectPage(){
      this.$router.push("promotions").catch(error =>{})
    },
    // setNewLoop(){
    //   this.continueRefreshInbox = setInterval( () => {
    //     this.getInboxList()
    //   }, 30000)
    // },
    getTopTenDepWit(){  //get top ten deposit withdrawal
      let url = config.getTopTenDepositWithdraw();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.topTenList = response.data.value
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
          }
        }
      );
      
    },
    firstBalance(){
      var vm = this
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              let newBalance = response.data
              // if (newBalance > this.currentBalance) {
              //   EventBus.$emit(
              //     "TOAST",
              //     "Congrats! You've won " + this.userCurrency + " " + this.$numeral(newBalance - this.currentBalance).format("0,0.00")
              //   );
              // }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    openSlotGame() {
      if (!this.$store.getters.isLoggedIn) {
        $("#modal-register01").modal("show");
        return;
      }
      if(this.sessionToken) {
        let account_id = this.$store.getters.accountID
        let auth_token = this.$store.getters.sessionToken
        let game_code = "0"
        let lang = "en-us"
        this.loading = true
        this.$store
          .dispatch("user/openSlotGame", { account_id, auth_token, game_code, lang })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              var wr = window.open();
              wr.location = response.data;
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status)
          });
      }
    },
    // getInboxList(){
    //   if(this.sessionToken) {
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     this.loading = true
    //     this.$store
    //       .dispatch("user/getInbox", { account_id, auth_token })
    //       .then(response => {
    //         this.loading = false
    //         this.feedback.success = response.success
    //         this.feedback.status = response.status
    //         if (this.feedback.success == true) {

    //         } else {
    //           this.feedback.status = this.$t("error." + response.status)
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         this.loading = false
    //         this.feedback.success = false
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //         this.feedback.status = this.$t("error." + response.status)
    //         $('body').removeClass('modal-open');
    //         $('.modal-backdrop').remove();
    //       });
    //   }
    // },
  }
}
</script>
<style lang="scss">
.no-scroll{
  overflow: hidden !important
}
.custom-top{
  @media(max-width: 767px){
    position: static;
  }
}
.carousel-indicators{
  bottom: -20px !important
}
.cib .amount{
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  color: #FFC000;
  position: absolute;
  width: 100%;
  text-align: center;
  top: -28px;
  z-index: 1;
  line-height: normal;
  @media(min-width: 681px) {
    font-size: 18px;
    top:-35px
  }
}
</style>
